module.exports = __webpack_public_path__ + "fonts/font.d9d89ae.woff2";